import { ArticleModel } from "../archive/article.model";
import { CompositeArticleModel } from "./composite-article.model";

export class CompositeArticleDetailModel {
    compositeArticleDetailId: number = 0;
    compositeArticleId: number = 0;
    compositeArticle: CompositeArticleModel | null = null;
    articleId: number = 0;
    article: ArticleModel | null = null;
    quantity: number = 0;
    createDate: Date = new Date;
    userNameCreate: string = '';
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}